module.exports = __webpack_public_path__ + "static/img/Leo.0f686fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/zodiac_image/Leo.svg
// module id = 1399
// module chunks = 0